import { reqGetRegion } from '@/api';

export default {
    // 用来存储数据
    state: {
        areas: [],
    },
    // 操作数据
    mutations: {
        ['areas'](state, { data }) {
            state.areas = data;
        },
    },
    // 响应组件中的事件
    actions: {
        async getRegionList({ commit }) {
            const re = await reqGetRegion();
            commit('areas', { data: re.data });
        },
    },
    // 用来将state数据进行加工
    getters: {},
    namespaced: true,
};
